import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as jwtDecode from 'jwt-decode';

@Injectable()
export class LoginService {
  constructor(private http: HttpClient) { }

  async logIn(email, password): Promise<any> {
    const body = { email, password };
    const loginResponse:any = await this.http.post('auth/login', body).toPromise()


    localStorage.setItem('token', loginResponse.token);
    const jwt = jwtDecode(loginResponse.token);

    const userResponse = await this.getUserGivenId(jwt.sub)
    localStorage.setItem('user', JSON.stringify(userResponse))
    return userResponse;
  }

  async getUserGivenId(id): Promise<any> {
    return this.http.get(`/user/${id}`)
      .toPromise()
      .then(user => user)
      .catch(err => {
        console.error(err);
        return err;
      });
  }

  updateUser(userObj): Promise<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const body = `_method=PUT&id=${userObj.id}&member_id=${userObj.member_id}&email=${userObj.email}&name=${userObj.name}`;
    return this.http.post(`/user/${userObj.id || -1}`, body, options)
      .toPromise()
      .then(this.handleUpdateUser)
      .catch(err => {
        console.error(err);
        return err;
      });
  }

  private handleUpdateUser(res: HttpResponse<Object>) {
    let body = res;
    console.log('User Updated ', body);
    return body;
  }

  isLoggedIn() {
    return localStorage.getItem('token')
  }

  getLoggedInUser() {
    if (localStorage.getItem('token')) {
      return JSON.parse(localStorage.getItem('user'));
    }
    return null;
  }

  async logOut() {
    const logoutResponse = await this.http.post('auth/logout', {}).toPromise();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return logoutResponse;
  }

  refreshToken(): Observable<string> {
    return this.http.post('auth/refresh', {}).map((d: any) => d.token);
  }
}
